export default {
  'password': 'Silakan masukkan kata sandi',
  'passwordError': 'Kata sandi harus terdiri dari 8-20 karakter dan hanya mendukung 3 atau lebih kombinasi huruf besar dan kecil, angka, dan simbol.',
  'passwordAgain': 'Silakan masukkan kata sandi lagi',
  'passwordNotSame': 'Kata sandi yang dimasukkan dua kali tidak konsisten',
  'requiredVerifyCode': 'Isi kode verifikasi',
  'verifyCode': 'Kode verifikasi salah'
}
